import { render, staticRenderFns } from "./ApplicantAddTemplate.vue?vue&type=template&id=3e883152"
import script from "./ApplicantAddTemplate.vue?vue&type=script&lang=ts"
export * from "./ApplicantAddTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\808325\\Documents\\SsmlockEntryReqWebApp-IVC202512\\SsmlockEntryReqWebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e883152')) {
      api.createRecord('3e883152', component.options)
    } else {
      api.reload('3e883152', component.options)
    }
    module.hot.accept("./ApplicantAddTemplate.vue?vue&type=template&id=3e883152", function () {
      api.rerender('3e883152', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/ApplicantTemplate/ApplicantAddTemplate.vue"
export default component.exports